// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 604 ? "company" : chunkId) + "-legacy." + {"98":"322ab667","465":"be5ab3f1","604":"1c1e17f6","864":"6a9d7e91","888":"847cb8b3"}[chunkId] + ".js";
};